import { render, staticRenderFns } from "./ContinueMyShoppingLink.vue?vue&type=template&id=278458ea&scoped=true&"
import script from "./ContinueMyShoppingLink.vue?vue&type=script&lang=js&"
export * from "./ContinueMyShoppingLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278458ea",
  null
  
)

export default component.exports